export const cleanBreadcrumbTitle = (path: any) => {
    // Remove all hyphens
    let cleanedPath = path.replace(/-/g, " ")
  
    // Remove the first part of the path if it's a sub-path
    const pathParts = cleanedPath.split("/").filter(Boolean)
    if (pathParts.length > 1) {
      pathParts.shift()
    }
  
    // Remove all forward slashes
    cleanedPath = pathParts.join(" ")
  
    // Capitalize the first letter of each word
    cleanedPath = cleanedPath
      .split(" ")
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ")
  
    return cleanedPath
  }
  